<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 标题 -->
    <div class="el_div">
      <el-button
      @click.native.prevent='addRow("add")'
      v-if="btn_permission.includes('sys:role:add')||btn_permission.includes('superAdmin')"
      type="primary">添加角色</el-button>
    </div>
    <!-- 角色列表 -->
    <el-table
    :data="listData"
    max-height="450"
    border
    :cell-style="{background:'#fff'}"
    id="emptransfer"
    >
      <el-table-column align="center" prop="id" label="角色ID"></el-table-column>
      <el-table-column label="角色名称">
        <template slot-scope="scope">
          <el-input :class="[scope.row.name_show==false?'active':'off_active']" :readonly='scope.row.name_show' @focus="name_span(scope.row)" @blur="name_input(scope.row)" v-model="scope.row.roleName"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="角色编码">
        <template slot-scope="scope">
          <el-input :class="[scope.row.code_show==false?'active':'off_active']" :readonly='scope.row.code_show' @focus="code_span(scope.row)" @blur="code_input(scope.row)" v-model="scope.row.roleCode"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="角色描述">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="scope.row.description" placement="top-start">
            <el-input :class="[scope.row.des_show==false?'active':'off_active']" :readonly='scope.row.des_show' @focus="des_span(scope.row)" @blur="des_input(scope.row)" v-model="scope.row.description"></el-input>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作">
        <template slot-scope="scope">
          <el-tag
          effect="dark"
          class="operate"
          @click.native.prevent='editRow(scope.row)'
          v-if="btn_permission.includes('sys:role:editAuth')||btn_permission.includes('superAdmin')"
          >
            编辑
          </el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="success"
          v-if="btn_permission.includes('sys:role:active')&&scope.row.status==0||btn_permission.includes('superAdmin')&&scope.row.status==0"
          @click='open_close(scope.row)'
          >启用</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="danger"
          v-if="btn_permission.includes('sys:role:disable')&&scope.row.status==1||btn_permission.includes('superAdmin')&&scope.row.status==1"
          @click='open_close(scope.row)'
          >禁用</el-tag>
          <el-tag
          class="operate"
          effect="plain"
          v-if="btn_permission.includes('sys:role:del')||btn_permission.includes('superAdmin')"
          @click.native.prevent='deleteRow(scope.row)'
          >
            删除
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="pageparm_size_change"
    @current-change="pageparm_current_change"
    :current-page="pageparm.currentPage"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="pageparm.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageparm.total"
    ></el-pagination>
    <!-- 添加角色 -->
    <el-dialog
    title="添加角色"
    :append-to-body='true'
    :visible.sync="roleVisible"
    customClass="role_dialog"
    >
      <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      >
        <el-form-item v-show="role_flag==true" label="角色名称" prop="roleName">
          <el-input v-model="ruleForm.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item v-show="role_flag==true" label="角色编码" prop="roleCode">
          <el-input v-model="ruleForm.roleCode" placeholder='请输入角色编码'></el-input>
        </el-form-item>
        <el-form-item v-show="role_flag==true" label="角色描述" prop="description">
          <el-input v-model="ruleForm.description" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="选择权限">
          <el-tree
          :data="tree_data"
          show-checkbox
          accordion
          ref="role_tree"
          :props="defaultProps"
          node-key="value"
          ></el-tree>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit_role()">提交</el-button>
          <el-button @click="resetChecked()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../Pagination.vue'
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        listData:[],//角色列表
        //分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        roleVisible:false,
        tree_data:[],//角色树形列表
        defaultProps:{
          children:'child',
          label:'name',
          disabled:'disabled'
        },
        ruleForm:{
          roleName:'',
          roleCode:'',
          description:'',
          ids:[]
        },
        //表单验证
        rules:{
          roleName:[
            {required:true,message:'请输入角色名称',trigger:'blur'}
          ],
          roleCode:[
            {required:true,message:'请输入角色编码',trigger:'blur'}
          ],
          description:[
            {required:true,message:'请输入角色描述',trigger:'blur'}
          ]
        },
        role_title:'添加角色',//新增或修改角色title
        role_flag:false,//新增还是修改
        role_id:'',
        //当前行
        now_row:{}
      }
    },
    components:{
      Pagination
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      that.pageparm.currentPage=1
      that.pageparm.pageSize=10
      //获取角色列表
      that.role_list()
    },
    mounted() {

    },
    methods:{
      //角色列表分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //获取角色列表
        this.role_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //获取角色列表
        this.role_list()
      },
      //获取角色列表
      role_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/role/list?page='+that.pageparm.currentPage+'&limit='+that.pageparm.pageSize
        }).then(data=>{
          if(data.data.success==false){
            that.$message.error(data.data.message)
          }else{
            //获取当前用户按钮权限
            that.$axios({
              method:'get',
              url:that.publicAjax.extra_path+'/admin/user/permission'
            }).then(data=>{
              if(data.data.success==true){
                that.btn_permission=data.data.data
              }else{
                that.$message.error(data.data.message)
              }
            })
            data.data.data.list.forEach(elem=>{
              that.$set(elem,'name_show',true)
              that.$set(elem,'code_show',true)
              that.$set(elem,'des_show',true)
              // elem.name_show=true
              // elem.code_show=true
              // elem.des_show=true
            })
            that.listData=data.data.data.list
            that.pageparm.total=data.data.data.total
          }
        })
      },
      //添加角色前置
      addRow(type){
        this.roleVisible=true
        let that=this
        that.role_flag=true
        that.role_title='添加角色'
        //获取角色权限列表
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/permission/roleAuthTree/'+type
        }).then(data=>{
          that.tree_data=data.data.data
          that.$refs.role_tree.setCheckedKeys([])
          that.$refs['ruleForm'].resetFields()
        })
      },
      //编辑角色前置
      editRow(row){
        let that=this
        that.role_flag=false
        that.role_title='修改权限'
        let arr=[]
        that.roleVisible=true
        that.role_id=row.id
        that.now_row=row
        //回显角色权限列表
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/permission/roleAuthTree/edit?roleId='+row.id
        }).then(data=>{
          that.tree_data=data.data.data
          that.tree_data.forEach(item=>{
            if(item.checked==true){
              arr.push(item.value)
            }
            item.child.forEach(item1=>{
              if(item1.checked==true){
                arr.push(item1.value)
              }
              item1.child.forEach(item2=>{
                if(item2.checked==true){
                  arr.push(item2.value)
                }
              })
            })
          })
          // that.$refs.role_tree.setCheckedKeys(arr)
          that.$nextTick(()=>{
            arr.forEach(value=>{
              that.$refs.role_tree.setChecked(value,true,false)
            })
          })
        })
      },
      //新增或修改角色权限
      submit_role(){
        let that=this
        that.ruleForm.ids=[]
        let submit_ids=that.$refs.role_tree.getCheckedNodes(false,true)
        submit_ids.forEach(item=>{
          that.ruleForm.ids.push(item.value)
        })
        if(that.role_flag==true){
          that.$refs['ruleForm'].validate((valid)=>{
            if(valid){
              //新增角色权限
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/admin/role',
                data:that.ruleForm,
                headers:{
                  "client": "web", //电脑浏览器:web,手机:mobile
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                  "content-type":"application/json;charset=UTF-8"
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.$message.success('添加角色成功')
                  that.roleVisible=false
                  //获取角色列表
                  that.role_list()
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }else{
              return false
            }
          })
        }else{
          //修改角色权限
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/admin/role/auth/'+that.role_id,
            data:{
              ids:that.ruleForm.ids
            },
            headers:{
              "client": "web", //电脑浏览器:web,手机:mobile
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success('修改 '+that.now_row.roleName+' 权限成功')
              that.roleVisible=false
              //获取角色列表
              that.role_list()
            }else{
              that.$message.error(data.data.message)
            }
          })
        }
      },
      //树形结构重置
      resetChecked(){
        this.$refs.role_tree.setCheckedKeys([])
        this.$refs['ruleForm'].resetFields()
      },
      //单元格获得焦点
      name_span(row){
        row.name_show=false
        row.old_roleName=row.roleName
      },
      code_span(row){
        row.code_show=false
        row.old_roleCode=row.roleCode
      },
      des_span(row){
        row.des_show=false
        row.old_description=row.description
      },
      //单元格失去焦点
      name_input(row){
        let that=this
        if(row.roleName!=''){
          row.name_show=true
          if(row.roleName!=row.old_roleName){
            //修改角色名称、编码、描述
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/role/base/'+row.id,
              data:{
                roleName:row.roleName,
                roleCode:row.roleCode,
                description:row.description
              },
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }else{
          that.$message.error('角色名称不能为空')
        }
      },
      code_input(row){
        let that=this
        if(row.roleCode!=''){
          row.code_show=true
          if(row.roleCode!=row.old_roleCode){
            //修改角色名称、编码、描述
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/role/base/'+row.id,
              data:{
                roleName:row.roleName,
                roleCode:row.roleCode,
                description:row.description
              },
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }else{
          that.$message.error('角色编码不能为空')
        }
      },
      des_input(row){
        let that=this
        if(row.description!=''){
          row.des_show=true
          if(row.description!=row.old_description){
            //修改角色名称、编码、描述
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/role/base/'+row.id,
              data:{
                roleName:row.roleName,
                roleCode:row.roleCode,
                description:row.description
              },
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }else{
          that.$message.error('角色描述不能为空')
        }
      },
      //启用或禁用角色
      open_close(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          if(row.status==0){
            //启用角色
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/role/active/'+row.id
            }).then(data=>{
              if(data.data.success==true){
                //获取角色列表
                that.role_list()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            //禁用角色
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/role/disable/'+row.id
            }).then(data=>{
              if(data.data.success==true){
                //获取角色列表
                that.role_list()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }).catch(()=>{

        })
      },
      //删除角色
      deleteRow(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/admin/role/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //获取角色列表
              that.role_list()
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped="scoped">
  .el_div{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .el-form{
    max-height: 350px;
    overflow: hidden;
    overflow-y: scroll;
  }
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
  .active{
    border: 1px solid #409eff !important;
    border-radius: 4px;
  }
  .off_active{
    border: 1px solid transparent !important;
  }
</style>
<style>
  #emptransfer .el-input__inner{
    border: 1px solid transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/role.vue